module.exports = __webpack_public_path__ + "img/updateEmail.e662f780.svg";